<template>
  <lateral-modal
    :title="$t('company_required_fields_modal_header')"
    @close="closeModal"
  >
    <template slot="content">
      <p class="Fuell-Text">{{$t('company_required_fields_modal_info')}}</p>
      <ul class="Fuell-List">
        <collapsable-item
          class="Fuell-List--item"
          v-for="(config, key) in officeFormsConfiguration"
          :key="config.id"
          @collapse="setActiveTab('RECEIPT', key)"
        >
          <template v-slot:header="{ showContent }">
            <span class="Fuell-List--header">{{$t(`company_required_fields_modal_form__${key}`)}}</span>
            <img
              :src="require('@/assets/img/icons/arrow-down-light.svg')"
              alt="icon-show"
              :class="{'rotate-arrow-up' : showContent}"
              class="icon--arrow"
            />
          </template>
          <template
            v-if="config.BILL && config.RECEIPT"
            v-slot:tab
          >
            <div class="container-tabs">
              <div
                class="tab"
                :class="{'active': activeTab[key] === 'RECEIPT'}"
                @click="setActiveTab('RECEIPT', key)"
              >{{$t('transactions_receipt_type_RECEIPT')}}</div>
              <div
                class="tab"
                :class="{'active': activeTab[key] === 'BILL'}"
                @click="setActiveTab('BILL', key)"
              >{{$t('transactions_receipt_type_BILL')}}</div>
            </div>
          </template>
          <template v-slot:content>
            <div class="d-flex flex-row justify-content-between mt-2 mb-3">
              <span class="Fuell-List-content--header">{{$t('company_required_fields_modal_option_field_name')}}</span>
              <span class="Fuell-List-content--header"> {{$t('company_required_fields_modal_option_field_required_status')}}</span>
            </div>
            <ul class="Fuell-List-content p-0">
              <li
                class="Fuell-List-content--item my-1"
                v-for="(option ,index) in generateMutableConfigList(config, key)"
                :key="index"
              >
                <span
                  v-if="key === EXPENSE_TYPES.TRANSACTION && option.field === 'provider'"
                  class="Fuell-Text"
                >{{$t(`company_required_fields_modal_form_field__transaction_${option.field}`)}}</span>
                <span
                  v-else
                  class="Fuell-Text"
                >{{$t(`company_required_fields_modal_form_field__${option.field}`)}}</span>
                <span class="mr-3">
                  <toggle-switch
                    :id="option.field + '-' + index"
                    :status.sync="option.isMandatory"
                    :label="''"
                    :disabled="key === EXPENSE_TYPES.TRANSACTION && activeTab[key] === 'BILL' && option.field === 'medias'"
                    updateOnChange
                    @change="toggleOptionStatus(key, config, option)"
                  />
                </span>
              </li>

            </ul>
          </template>
        </collapsable-item>
      </ul>
    </template>
  </lateral-modal>
</template>

<script>
import { EXPENSE_TYPES } from '@/modules/transactions/_constants/constants'
import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'
import CollapsableItem from '@/components/Commons/CollapsableItem'
import ToggleSwitch from '@/components/Commons/Forms/ToggleSwitch'
import LateralModal from '@/components/Commons/Modals/LateralModal'

export default {
  name: 'RequiredFieldsSettingsModal',
  mixins: [_modalHandlerMixin],
  components: { CollapsableItem, ToggleSwitch, LateralModal },
  data () {
    return {
      officeForm: [],
      activeTab: {
        TRANSACTION: 'RECEIPT',
        EXPENSE: 'RECEIPT'
      }
    }
  },
  computed: {
    EXPENSE_TYPES () {
      return EXPENSE_TYPES
    },
    officeFormsConfiguration () {
      return this.$store.getters['CompanyStore/officeFormConfigurations']
    }
  },
  methods: {
    setActiveTab (tab, type) {
      this.activeTab[type] = tab
    },
    generateMutableConfigList (configItem, type) {
      const item = this.activeTab[type]
      if (configItem[item]) {
        return configItem[item].configuration.filter(el => el.isMutable)
      }
      return configItem.configuration.filter(el => el.isMutable)
    },
    async toggleOptionStatus (key, config, option) {
      const item = this.activeTab[key]
      let optionToEdit = {}
      let configuration = []
      if (config[item]) {
        optionToEdit = this.officeFormsConfiguration[key][item].configuration.find(el => el.field === option.field)
        optionToEdit.isMandatory = !optionToEdit.isMandatory
        configuration = config[item].configuration
      } else {
        optionToEdit = this.officeFormsConfiguration[key].configuration.find(el => el.field === option.field)
        optionToEdit.isMandatory = !optionToEdit.isMandatory
        configuration = config.configuration
      }
      let officeFormData = {
        form: key,
        id: config.id || config[item].id,
        configuration: [...configuration]
      }

      await this.$store.dispatch('CompanyStore/updateOfficeFormConfiguration', { configId: config.id || config[item].id, officeForm: officeFormData })
    }
  },
  async created () {
    await this.$store.dispatch('CompanyStore/fetchOfficeFormConfigurations', null, { root: true })
  },

  beforeRouteUpdate (to, from, next) {
    this.closeModal()
    next()
  }

}
</script>

<style lang="scss" scoped>
.Fuell-List {
  margin-left: 0px;
  padding: 0px;
  &--header {
    font-weight: 500;
  }
  &-content--header {
    color: var(--text-heading);
  }
}
.Fuell-List--item,
.Fuell-List-content--item {
  list-style-type: none;
}

.Fuell-List-content--item {
  display: flex;
  justify-content: space-between;
}
.icon--arrow {
  width: 12px;
  height: 100%;
  margin-left: 4px;
}
.rotate-arrow-up {
  transform: rotate(180deg);
}
.Fuell-List--item:first-of-type {
  border-top: none;
}

.Fuell-List--item:last-of-type {
  border-bottom: none;
}
.container-tabs {
  display: flex;
  height: 40px;
  padding: 2px;
  background: var(--fill-background);
  cursor: pointer;
  .tab {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50%;
    font-weight: 400;
    font-size: 15px;
    line-height: 24px;
    text-align: center;
    color: var(--text-placeholder);
    &.active {
      background: var(--white);
      border: 1px solid var(--fill-border);
      box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.08);
      border-radius: 2px;
      font-weight: 600;
      color: var(--text-heading);
    }
  }
}
</style>
